var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_405_1368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 21C4.83696 21 4.20107 20.7366 3.73223 20.2678C3.26339 19.7989 3 19.163 3 18.5V1.5C3 1.10218 2.84196 0.720644 2.56066 0.43934C2.27936 0.158035 1.89782 0 1.5 0V0C1.10218 0 0.720644 0.158035 0.43934 0.43934C0.158035 0.720644 0 1.10218 0 1.5L0 18.5C0 19.9587 0.579463 21.3576 1.61091 22.3891C2.64236 23.4205 4.04131 24 5.5 24H22.5C22.8978 24 23.2794 23.842 23.5607 23.5607C23.842 23.2794 24 22.8978 24 22.5C24 22.1022 23.842 21.7206 23.5607 21.4393C23.2794 21.158 22.8978 21 22.5 21H5.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 18C19.8978 18 20.2794 17.842 20.5607 17.5607C20.842 17.2794 21 16.8978 21 16.5V10.5C21 10.1022 20.842 9.72064 20.5607 9.43934C20.2794 9.15804 19.8978 9 19.5 9C19.1022 9 18.7206 9.15804 18.4393 9.43934C18.158 9.72064 18 10.1022 18 10.5V16.5C18 16.8978 18.158 17.2794 18.4393 17.5607C18.7206 17.842 19.1022 18 19.5 18Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18C7.89782 18 8.27936 17.842 8.56066 17.5607C8.84196 17.2794 9 16.8978 9 16.5V10.5C9 10.1022 8.84196 9.72064 8.56066 9.43934C8.27936 9.15804 7.89782 9 7.5 9C7.10218 9 6.72064 9.15804 6.43934 9.43934C6.15804 9.72064 6 10.1022 6 10.5V16.5C6 16.8978 6.15804 17.2794 6.43934 17.5607C6.72064 17.842 7.10218 18 7.5 18Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 17.9994C13.8978 17.9994 14.2794 17.8414 14.5607 17.56C14.842 17.2787 15 16.8972 15 16.4994V5.49939C15 5.10156 14.842 4.72003 14.5607 4.43873C14.2794 4.15742 13.8978 3.99939 13.5 3.99939C13.1022 3.99939 12.7206 4.15742 12.4393 4.43873C12.158 4.72003 12 5.10156 12 5.49939V16.4994C12 16.8972 12.158 17.2787 12.4393 17.56C12.7206 17.8414 13.1022 17.9994 13.5 17.9994Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_405_1368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsWhite);
export default __webpack_public_path__ + "static/media/stats_white.87be0a026fd0cf69e601d6a284074d73.svg";
export { ForwardRef as ReactComponent };